<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Tìm kiếm, tra cứu thông tin nhật ký đồng bộ dữ liệu trên Elastic Search</strong>
          </div>
          <b-form @submit.prevent="search">
            <b-row>
              <b-col lg="6">
                <b-form-group label="Ngày đồng bộ từ:"
                              :label-cols-md="4"
                              :horizontal="true"
                              label-align="left">
                  <date-picker id="input-startdate" v-model="searchForm.syncStartDate" placeholder="dd/mm/yyyy"></date-picker>
                </b-form-group>
                <b-form-group label="Đến:"
                              :label-cols-md="4"
                              :horizontal="true"
                              label-align="left">
                  <date-picker id="input-enddate" v-model="searchForm.syncEndDate" placeholder="dd/mm/yyyy"></date-picker>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Loại dữ liệu đồng bộ:"
                              :label-cols-md="4"
                              :horizontal="true"
                              label-align="left">
                  <select2 v-model="searchForm.indexName" :options="elasticIndexes"
                           style="width:100%"></select2>
                </b-form-group>
                <b-form-group label="Trạng thái:"
                              :label-cols-md="4"
                              :horizontal="true"
                              label-align="left">
                  <select2 v-model="searchForm.status" :options="syncStatuses"
                           style="width:100%"
                           allowClear="true"
                           placeholder="--- Tất cả ---"></select2>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Mã đồng bộ (UUID):"
                              :label-cols-md="4"
                              :horizontal="true"
                              label-align="left">
                  <b-input v-model="searchForm.logId"></b-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Layer:"
                              :label-cols-md="4"
                              :horizontal="true"
                              label-align="left">
                  <select2 v-model="searchForm.layer" :options="layers"
                           style="width:100%"
                           allowClear="true"
                           placeholder="--- Tất cả ---"></select2>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <b-col sm="12">
                <b-button type="submit" variant="primary">Tìm kiếm</b-button>
              </b-col>
            </b-row>
          </b-form>
          <b-grid :searchForm="searchForm"
                  :gridOptions="logGridOptions"
                  :showActions="true"
                  dataUrl="logging/elastic"
                  gridName="Danh sách nhật ký đồng bộ dữ liệu sang QLTSC"
                  ref="elasticLogGroupTable">
            <template v-slot:cell(timestamp)="row">
              {{ row.value | formatTime }}
            </template>
            <template v-slot:cell(status)="row">
              <span :class="isSuccess(row.item) ? 'text-success' : 'text-danger'">{{ isSuccess(row.item) ? 'Thành công' : 'Thất bại' }}</span>
            </template>
            <template v-slot:cell(syncDataType)="row">
              {{ getSyncDataType(row.item) }}
            </template>
            <template v-slot:cell(_actions)="row">
              <b-button size="sm" @click="showDetail(row.item, row.index, $event.target)" class="mr-2" variant="info">
                Xem chi tiết
              </b-button>
            </template>
          </b-grid>
        </b-card>
      </b-col>
    </b-row>

    <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" ok-only>
      <json-viewer :data="infoModal.content"></json-viewer>
    </b-modal>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { mixins } from '@/shared/mixins'

  export default {
    name: 'ListElasticLog',
    mixins: [mixins],
    data() {
      return {
        searchForm: {
          indexName: 'logs-assets',
          syncStartDate: null,
          syncEndDate: new Date().formatDate(),
          status: null,
          layer: null,
          logId: null
        },
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        logGridOptions: {
          fields: [
            { key: 'uuid', label: 'Mã đồng bộ (UUID)', sortable: false },
            { key: 'layer', label: 'Layer', sortable: false },
            { key: 'syncUnitCode', label: 'Đơn vị đồng bộ', sortable: false },
            { key: 'timestamp', label: 'Ngày đồng bộ', sortable: false },
            { key: 'syncDataType', label: 'Loại dữ liệu', sortable: true },
            { key: 'status', label: 'Trạng thái', sortable: false },
            { key: 'info', label: 'Thông tin', sortable: false },
            { key: 'errorMessage', label: 'Lỗi', sortable: false },
          ],
        },
        layers: [
          { id: 'controller', text: 'Controller' },
          { id: 'listener', text: 'Listener' },
          { id: 'parser', text: 'Parser' },
          { id: 'cleaner', text: 'Cleaner' },
          { id: 'saving', text: 'Saving' },
        ],
        syncStatuses: [
          { id: 1, text: 'Thành công' },
          { id: 0, text: 'Thất bại' }
        ],
        elasticIndexes: [
          { id: 'logs-assets', text: 'Tài sản' },
          { id: 'logs-ms-category', text: 'Danh mục' },
          { id: 'logs-wsts2', text: 'Báo cáo' }
        ]
      }
    },
    computed: {
      ...mapState({
        assetMutationTypes: (state) => state.common.assetMutationTypes,
      })
    },
    created() {
    },
    methods: {
      search() {
        this.$refs.elasticLogGroupTable.refresh();
      },
      getSyncDataType(item) {
        try {
          var jsonData = JSON.parse(item.detailData);
          return item.masterDataType ?? item.categoryType ?? item.serviceName ?? jsonData.reportTypeCode ?? this.getAssetMutationType(jsonData) ?? jsonData.tableName;
        } catch {
          return item.masterDataType ?? item.categoryType ?? item.serviceName;
        }
      },
      getAssetMutationType(json) {
        try {
          var id = json.assetMutationTypeId ?? (json.data ? json.data[0].assetMutationTypeId : '')
          var type = this.assetMutationTypes.find(x => x.id == id)
          return type != null ? type.text : null;
        } catch {
          return null;
        }
      },
      showDetail(item, index, button) {
        this.infoModal.title = `Thông tin dữ liệu được đồng bộ`;
        this.infoModal.content = item.detailData;
        this.$root.$emit('bv::show::modal', this.infoModal.id, button);
      },
      isSuccess(item) {
        if (item.status == 1) return true;
        if (item.totalRecords > 0) return true;

        return false;
      }
    }
  }
</script>